import { QueryHookOptions, useQuery } from '@apollo/client';
import { GET_STAGE_FIELD_SCHEMAS_QUERY } from '@frontend/app/queries/GetCustomStagesFieldSchemas';
import {
  StageFieldSchemasQuery,
  StageFieldSchemasQueryVariables,
} from '@frontend/app/queries/types/StageFieldSchemasQuery';

type IOptions = QueryHookOptions<StageFieldSchemasQuery, StageFieldSchemasQueryVariables>;

interface IParams extends StageFieldSchemasQueryVariables {}

export const useGetStageFieldSchemas = ({ programId, stageId }: IParams, options: IOptions = {}) => (
  useQuery<StageFieldSchemasQuery, StageFieldSchemasQueryVariables>(
    GET_STAGE_FIELD_SCHEMAS_QUERY,
    {
      variables: { programId, stageId },
      ...options,
    }
  )
);
